/**
 * Entry point.
 *
 * The budget that governs this file: cold start to an interactive Catch button
 * in under one second on a mid-range Android (architecture A3/§2.7). "Interactive"
 * means tappable *before any store read completes* — so nothing here awaits
 * IndexedDB, and everything that needs derived state renders a beat later.
 */

import { mount } from 'svelte';
import '$ui/styles/base.css';
import App from '$ui/App.svelte';

const target = document.getElementById('app');
if (!target) throw new Error('Missing #app mount point');

mount(App, { target });
